import { tracked } from '@glimmer/tracking';
import JournalDecisionModel from 'donor-elf-web/models/journal-decision';

export default class JournalContactInfoOnlyDecision {
  constructor(journalDecisions: JournalDecisionModel[]) {
    this.journalDecisions = journalDecisions;
  }
  @tracked journalDecisions!: JournalDecisionModel[];
}

export interface JournalContactInfoOnlyDecisionInterface {
  journalDecisions: JournalDecisionModel[];
}
